// extracted by mini-css-extract-plugin
module.exports = {"icon":"CursorIcon_icon__IxKsl","icon_chevron-left":"CursorIcon_icon_chevron-left__V9j6E"};